// Shared external links surfaced in the UI. Kept in one place so the same URL
// can be referenced from the Guide page and the New-deck intake without drifting.

/** The RKH "Deck brief" template: a Google Doc staff copy (File > Make a
 *  copy), write their brief into, then upload in New deck. Replaced 2026-08-05:
 *  the old Doc taught the retired #-marker vocabulary; this one teaches the
 *  plain-paragraph shape the guide and worked example use. Owned by
 *  jdickinson@rkh.co.uk; shared org-wide as viewer. */
export const BRIEF_TEMPLATE_URL =
  'https://docs.google.com/document/d/1ocIBKphRw_FPg1iJrd-cgWP8l_uYT3rpnDY9DH-Am9Y/edit';

/** A downloadable worked example: a real, well-structured brief (the deep-ocean
 *  deck) plus the photos it references. Zipped on the fly by the server from
 *  studio/examples/deep-ocean/. Lets staff see what good input looks like and
 *  build it for themselves. */
export const EXAMPLE_BRIEF_ZIP_URL = '/api/examples/deep-ocean-brief.zip';
